class e extends Error {
}
class s extends e {
}
class n extends e {
}
export {
  n as MissingReflexActionError,
  e as ReflexError,
  s as UnknownRefError
};
